"use client";

import { Button } from "@/components/shadcn/button";
import { cn } from "cn";
import { ReactNode } from "react";
import { PlayerNickname } from "../player-nickname";

interface InviteCardProps {
    from?: {
        nickname?: string;
        userId?: number;
        isPremium?: boolean;
    };
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    metadata?: ReactNode;
    onAccept: () => void;
    onDecline: () => void;
    isLoading?: boolean;
    acceptLabel?: string;
    declineLabel?: string;
    className?: string;
}

export function InviteCard({
    from,
    title,
    subtitle,
    metadata,
    onAccept,
    onDecline,
    isLoading = false,
    acceptLabel = "Kabul Et",
    declineLabel = "Reddet",
    className,
}: InviteCardProps) {
    return (
        <div
            className={cn(
                "hover:border-primary/50 rounded-lg border bg-gray-50 p-3 shadow-sm transition-all",
                className,
            )}
        >
            <div className="mb-2 overflow-hidden">
                <div className="text-sm leading-tight font-medium text-gray-900">
                    {from?.nickname ? (
                        <span className="inline-flex flex-wrap items-center gap-1">
                            <PlayerNickname
                                nickname={from.nickname}
                                isPremium={from.isPremium}
                                userId={from.userId}
                                iconSize={16}
                            />{" "}
                            <span className="font-normal">{title}</span>
                        </span>
                    ) : (
                        title
                    )}
                </div>
                {subtitle && (
                    <div className="mt-1 truncate text-xs text-gray-600">
                        {subtitle}
                    </div>
                )}
                {metadata && <div className="mt-2 text-xs">{metadata}</div>}
            </div>

            <div className="flex gap-2 pt-1">
                <Button
                    size="sm"
                    className="h-8 flex-1 text-xs font-semibold"
                    disabled={isLoading}
                    onClick={onAccept}
                >
                    {acceptLabel}
                </Button>
                <Button
                    size="sm"
                    variant="outline"
                    className="h-8 flex-1 text-xs font-medium"
                    disabled={isLoading}
                    onClick={onDecline}
                >
                    {declineLabel}
                </Button>
            </div>
        </div>
    );
}
